import { singularityStore } from "@/store/store";
import { getPagesFromWPAndPlaceInStore } from "./wp-page-manager/pages";

export function setUi(step: "step1" | "step2" | "step3" | "step4" | "step5") {
  switch (step) {
    case "step1":
      setUiForStep1();
      break;
    case "step2":
      setUiForStep2();
      break;
    case "step3":
      break;
  }
}

function setUiForStep1() {
  singularityStore.setSingularityRightPanel("step1");
  singularityStore.setSingularityLeftPanel(null);
}

function setUiForStep2() {
  getPagesFromWPAndPlaceInStore();
  singularityStore.setSingularityRightPanel(null);
  singularityStore.setSingularityLeftPanel("page_structure");
}
